var container = document.getElementsByClassName("header-container");
var imageHeader = document.getElementsByClassName("swiper-slide-header");
var imageContainer = document.getElementsByClassName("image-container");
var backgroundSolidMedium = document.getElementsByClassName("mediumHeader");
var backgroundSolidSmall = document.getElementsByClassName("smallHeader");
var header = document.getElementsByClassName("headerSite");
var articleCards = document.getElementsByClassName("article-cards");
var shopCards = document.getElementsByClassName("shop-cards");
var offerCards = document.getElementsByClassName("offer-cards");
var eventCards = document.getElementsByClassName("event-cards");

const sizes = {}
sizes.width = window.innerWidth
sizes.height = window.innerHeight

let headerMarginBottom = 0;

window.addEventListener('resize', () =>
{
	sizes.width = window.innerWidth
	sizes.height = window.innerHeight
	
})

if(sizes.width < 900) {
	headerMarginBottom = 60;
}
else {
	headerMarginBottom = 120;
}

// To define the height of the slide buttons
if(container.length !== 0){
	
	for(let i =0; i <imageHeader.length; i++){
		if(sizes.width > 414){
			imageHeader[i].style.height = (sizes.width / 3.06) + "px";
		}
	}

}

// HANDLE THE RATIO OF THE HEADER IF NOT MOBILE
if(sizes.width > 414){

	if(imageContainer.length !== 0){
		imageContainer[0].style.height = (sizes.width / 3.06) + "px";
	}

	if(backgroundSolidMedium.length !== 0) {
		backgroundSolidMedium[0].style.height = (sizes.width/ 3.06) +"px";
	}

	if(backgroundSolidSmall.length !== 0) {
		backgroundSolidSmall[0].style.height = (sizes.width / 7) +"px";
	}
}



if(articleCards.length !==0) {
	caclMoreHeight(articleCards);
}


if(offerCards.length !==0) {
	if(sizes.width > 767){
		let bottomOffer = offerCards[0].offsetHeight - 107;
		offerCards[0].style.bottom = - bottomOffer + 'px';
		header[0].style.marginBottom = (headerMarginBottom + bottomOffer) + "px";
	}
	else {
		caclMoreHeight(offerCards);
	}	
}

if(shopCards.length !==0) {
	let bottomShop = shopCards[0].offsetHeight /2;
	shopCards[0].style.bottom = -bottomShop + 'px';
	header[0].style.marginBottom = (headerMarginBottom + bottomShop) + "px";
}

if(eventCards.length !==0) {
	let moreHeight = eventCards[0].offsetHeight + 40 - header[0].offsetHeight;
		if(moreHeight > 0){
			header[0].style.height = (header[0].offsetHeight + moreHeight) + "px";
		}
		if(moreHeight <= 0)
		{
			let bottomEvent = eventCards[0].offsetHeight - 76;
			eventCards[0].style.bottom = - bottomEvent + "px";
			eventCards[0].style.top = "auto";
			header[0].style.marginBottom = (headerMarginBottom + bottomEvent) + "px";
		}
}

function caclMoreHeight(styleCard) {

	if(sizes.width < 900){
		let moreHeight = styleCard[0].offsetHeight + 40 - header[0].offsetHeight;
		if(moreHeight > 0){
			header[0].style.height = (header[0].offsetHeight + moreHeight) + "px";
		}
		if(moreHeight <= 0)
		{
			let bottomStyleCard = styleCard[0].offsetHeight - 76;
			styleCard[0].style.bottom = - bottomStyleCard + "px";
			styleCard[0].style.top = "auto";
			header[0].style.marginBottom = (headerMarginBottom + bottomStyleCard) + "px";
		}
	}
	
	
}